import { useIsWorkbookAnalyzing } from "@/hooks/use-is-workbook-analyzing";
import queries from "@/queries";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef } from "react";

/**
 * XBRL 분석 완료 감시 — 매핑 페이지 루트에 1회 마운트한다.
 *
 * 분석이 끝나도 화면은 폴링하던 task status 만 갱신될 뿐, 워크북 상태와 태깅 안내는
 * 옛 답을 그대로 들고 있다. 그래서 분석 중에 들어온 유저는 분석이 끝나도 버튼이
 * 비활성인 채로, 다음 액션 안내도 뜨지 않은 채로 남는다. 진행 중 → 완료 전환 시:
 *
 * - DSD 목록 무효화 → 워크북 status(XBRL_ANALYZED)가 갱신돼 버튼이 활성화된다.
 * - 태깅 안내 무효화 → 분석 중에 받은 NONE 을 버리고 다시 받는다.
 */
export const useXbrlAnalysisCompletionEffect = (
  workbookId: string | undefined,
) => {
  const queryClient = useQueryClient();
  const isAnalyzing = useIsWorkbookAnalyzing(workbookId);
  const wasAnalyzingRef = useRef(false);

  useEffect(() => {
    if (isAnalyzing) {
      wasAnalyzingRef.current = true;
      return;
    }
    if (!wasAnalyzingRef.current || !workbookId) return;
    wasAnalyzingRef.current = false;

    queryClient.invalidateQueries({ queryKey: queries.dsd().queryKey });
    queryClient.invalidateQueries({
      queryKey: queries.workbook(workbookId)._ctx.taggingGuidance().queryKey,
    });
  }, [isAnalyzing, workbookId, queryClient]);
};
